import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/vendor/consignment-vendor-product/")({
	component: () => null,
});
